import { call, put } from 'redux-saga/effects';
import { SOCIAL_LINKS } from '@piconetworks/pkg-endpoints';
import { picoAPIHelper } from '@piconetworks/pkg-network-middleware';

function createLink(_ref) {
  var types = _ref.types,
    publisherId = _ref.publisherId,
    _ref$payload = _ref.payload,
    icon = _ref$payload.icon,
    link_block_id = _ref$payload.link_block_id,
    order = _ref$payload.order,
    title = _ref$payload.title,
    subtitle = _ref$payload.subtitle,
    url = _ref$payload.url;
  return function* () {
    try {
      var _yield$call = yield call(picoAPIHelper, {
          url: SOCIAL_LINKS({
            scope: 'creator'
          }),
          method: 'post',
          headers: {
            publisherid: publisherId
          },
          data: {
            icon: icon,
            link_block_id: link_block_id,
            order: order,
            title: title,
            subtitle: subtitle,
            url: url
          }
        }),
        data = _yield$call.data;
      if (data) {
        yield put({
          type: types.CREATE_LINK_SUCCESS,
          payload: data
        });
      } else {
        throw new Error('unable to create link');
      }
    } catch (error) {
      yield put({
        type: types.CREATE_LINK_ERROR,
        error: error === null || error === void 0 ? void 0 : error.message
      });
    }
  }();
}

export { createLink as default };
//# sourceMappingURL=createLink.js.map
